import { z } from 'zod';
import { creditLineFormFields } from './line-form-fields.js';
import { refineCreditLineForm } from './refine-credit-line-form.js';
export const promotionCreditLineFormSchema = z
    .object(creditLineFormFields)
    .superRefine(refineCreditLineForm);
//# sourceMappingURL=line-form.js.map